import { usePortal } from '@financial/common-hooks';
import Overlay from './Overlay.mjs';
import { TopLayerWrapperContainer } from './TopLayerWrapperContainer.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

/**
 * @deprecated
 * @description 이 함수는 더이상 유지보수 되지 않습니다. @defign/ui의 useTopModal 를 사용해주세요.
 */
const TopLayerWrapper = _ref => {
  let {
    children,
    shouldShow,
    closeFn,
    preventBackgroundScroll = false
  } = _ref;
  const Portal = usePortal();
  if (!shouldShow) {
    return null;
  }
  return /*#__PURE__*/jsx(Portal, {
    children: /*#__PURE__*/jsxs(TopLayerWrapperContainer, {
      children: [/*#__PURE__*/jsx(Overlay, {
        isShow: shouldShow,
        onClick: closeFn,
        preventBackgroundScroll: preventBackgroundScroll,
        zIndex: 10
      }), children]
    })
  });
};
var TopLayerWrapper$1 = TopLayerWrapper;

export { TopLayerWrapper$1 as default };
